/**
 * wql
 * @description 个人证书记录管理页面配置
 * @Date 2020/9/15
 */
import React from 'react'
import {component_tool, utils_tool} from '../../../tool';
import { WizTableForm } from '../../common'
import moment from "moment";
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
let { WizModal } = component_tool;
let { $$, checkStrLength, dateUtils} = utils_tool
const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 13, state: 1}})

//配置项
let componentName = 'certRecord'
let selectedRows = []

const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "personId",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    searchItem: {},
    tableItem: {
      width: 70
    },
  },
  {
    title: "账号",
    name: "userName",
    searchItem: {},
    tableItem: {
      width: 120
    },
  },
  {
    title: "账号状态",
    name: "userState",
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 100
    },
    dict: [
      { code: 1, codeName: '激活' },
      { code: 0, codeName: '禁用' },
    ],
  },
  {
    title: "组织",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: '岗位',
    name: 'posIds',
    searchItem: {
      ...positionConfig,
      diy: WizTableForm
    }
  },
  {
    title: "证书名称",
    name: "certName",
    searchItem: {},
    tableItem: {
      width: 200
    },
  },
  {
    title: "证书编号",
    name: "certCode",
    searchItem: {},
    tableItem: {
      width: 150
    },
  },
  {
    title: "证书分类",
    name: "categoryStr",
    dataIndex: "categoryStr",
    tableItem: {
      width: 150
    }
  },
  {
    title: '证书分类',
    name: 'categoryIds',
    searchItem: {
      ...categoryConfig,
      diy: WizTableForm,
      onSelectedRows:(ff,dd)=> {
          selectedRows = ff?.map(item=>item?.id);
        },
      selectType: 'checkbox',
      tableProps:{
        needOnRowSelect: (record, index) => {
          return !((!selectedRows.includes(record.id)) && selectedRows?.length >=3 )
        },
        rowSelection: {columnTitle:' ',
          hideDefaultSelections:true,
          getCheckboxProps: (record) => {
            return { disabled: (!selectedRows.includes(record.id)) && selectedRows?.length >=3 }
          }
      }
      },
    },
  },
  {
    title: "证书类别",
    name: "certType",
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 150
    },
    dict: [
      { code: 1, codeName: '培训证书' },
      { code: 2, codeName: '社会证书' },
    ],
  },
  {
    title: '证书获取时间',
    name: 'gainTime',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: "获得途径",
    name: "channel",
    tableItem: {
      width: 150
    },
  },
  {
    title: "数据来源",
    name: "dataSource",
    tableItem: {
      width: 150
    },
    dict: [
      { code: 0, codeName: '人工导入' },
      { code: 1, codeName: '系统生成' },
    ],
  },
  {
    title: "证书获取时间",
    name: "certDate",
    tableItem: {
      width: 200,
      render: (text, record) => {
        return text ? dateUtils.formatDateString(text,'yyyy-MM-dd') : '';
      }
    },
  },
  {
    title: "证书状态",
    name: "state",
    dataIndex: "state",
    dict: [
      { code: 0, codeName: '无效' },
      { code: 1, codeName: '有效' },
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 100,
    },
  },
  {
    title: "最后更新时间",
    name: "updateTime",
    tableItem: {
    },
  },
  //{
   // title: "邮寄申请状态",
   // name: "applyStatusStr",
    //tableItem: {
    //  width: 120,
    //},
 // },
  //{
    //title: "邮寄申请状态",
    //name: "applyStatus",
    //dataIndex: "applyStatus",
    //dict: [
    //  { code: 0, codeName: '待申请' },
    //  { code: 1, codeName: '已申请' },
   // ],
   // searchItem: {
    //  type: 'select'
    //}
  //},
  {
    title: '申请人姓名',
    name: 'applyPersonIdList',
    searchItem: {
      ...userConfig,
      diy: WizTableForm
    }
  },
  {
    title: "申请人",
    name: "applyFullName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "申请人账号",
    name: "applyUserName",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "申请时间",
    name: "applyTimeStr",
    tableItem: {
      width: 130,
    },
  },
  //{
  //  title: "邮寄地址",
   // name: "address",
   // tableItem: {
   //   width: 130,
   // },
 // },
 // {
  //  title: "收件人",
   // name: "touchPersonName",
   // tableItem: {
   //   width: 100,
   // },
  //},
  {
    title: "联系电话",
    name: "touchPhone",
    tableItem: {
      width: 120,
    },
  },
  //{
   // title: "邮寄状态",
   // name: "postStatusStr",
   // tableItem: {
   //   width: 100,
   // },
  //},
  //{
   // title: "邮寄状态",
    //name: "postStatus",
    //dataIndex: "postStatus",
   // dict: [
   //   { code: 0, codeName: '待邮寄' },
   //   { code: 1, codeName: '已邮寄' },
   // ],
   // searchItem: {
   //   type: 'select'
   // }
 // },
  //{
    //title: "邮寄时间",
   // name: "postTimeStr",
   // tableItem: {
   //   width: 130,
   // },
  //},
  //{
   // title: "是否签收",
   // name: "signStatus",
   // dataIndex: "signStatus",
   // dict: [
   //   { code: 0, codeName: '是' },
   //   { code: 1, codeName: '否' },
   // ],
  //  searchItem: {
   //   type: 'select'
   // }
  //},
  //{
  //  title: "是否签收",
   // name: "signStatusStr",
   // tableItem: {
   //   width: 100,
    //},
  //},
  //{
   // title: "签收时间",
   // name: "signTimeStr",
   // tableItem: {
   //   width: 130,
    //},
  //},
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort:['add','postConfirm','export','import','exportByEmploymentInfo'],
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['gainTime'] && value['gainTime'].length === 2) {
            value['startDate'] = moment(value['gainTime'][0]).format("YYYY-MM-DD") + ' 00:00:00';
            value['endDate'] = moment(value['gainTime'][1]).format("YYYY-MM-DD") + ' 23:59:59';
          }
          // delete value['gainTime']
          return value
        },
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/personalCert/personalCertList/personalCertAdd'
              }
            }
          },
          {
            key: "postConfirm",
            custom: true,
            needSelect: true,
            params: { icon: "into", children: "证书邮寄确认", type: "info" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "postConfirm",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                const content = '你确定要邮寄确认选中的学员证书吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']) {
                    ids.push(e['id']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      trainCertRecordIdList: ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length>0){
                rows.forEach(item => {
                  let {applyStatus,postStatus} =item;
                  if (applyStatus ==null || applyStatus!=1){
                    disabled=1;
                  }
                  if (postStatus ==null || postStatus!=0){
                    disabled=1;
                  }
                })
              }else {
                disabled = 1;
              }
              return { disabled: disabled }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
            }
          },
          {
            key: 'exportByEmploymentInfo',
            custom: true,
            params: { icon: 'export', children: '按任职导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "exportNew",
                apiParams: {}
              },
            }
          },
          {
            key: 'import',
            custom: true,
            params: { icon: 'import', children: '导入', type: 'import'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/personalCert/certImport',
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
        rowOperateSort:['look','update','enableOrDisable','viewJobs'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/personalCert/personalCertList/personalCertUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "禁用"},
          textFormat: {
            recordKey: 'state',
            dirt: { 0: '启用', 1: '禁用'}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
              }该证书记录？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 0 ? 1 : 0,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/personalCert/personalCertList/personalCertInfo"
            }
          }
        },
        {
          key: "viewJobs",
          custom: true,
          params: { children: "查看任职"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/personalCert/personalCertList/lookPositionInfo"
            }
          }
        }
      ]
    }
  }
};


const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  import: {
    path: `${componentName}/importFile`,
    payload: {
      key: `${componentName}@exportTrainPathInfo`,
      apiParams: {}
    }
  },
  // export: {
  //   path: `${componentName}/export`,
  //   payload: {
  //     key: `${componentName}@getPathContent`,
  //     apiParams: {}
  //   }
  // },
  // exportNew: {
  //   path: `${componentName}/exportNew`,
  //   payload: {
  //     key: `${componentName}@exportNew`,
  //     apiParams: {}
  //   }
  // },
  export: {
    path: `${componentName}/exportDetailFile`,
    payload: {
      key: `${componentName}@exportDetailFile`,
      apiParams: {}
    }
  },
  exportNew: {
    path: `${componentName}/exportDetailByIdentityFile`,
    payload: {
      key: `${componentName}@exportDetailByIdentityFile`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  postConfirm: {
    path: `${componentName}/postConfirm`,
    payload: {
      key: `${componentName}@postConfirm`,
      apiParams: {}
    }
  },
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
